import React from "react";
import Editor from "../Editor/Editor";
import List, {ListPropsType} from "./List";

export default React.forwardRef<any, Partial<ListPropsType&{[key: string]: any}>>((props, ref) => {
    return <List
        ref={ref}
        component="Translation"
        fields={{
            "actions": {
                header: (_props) => {
                    return <Editor
                        {..._props}
                        children={null}
                        dirtyValues={false}
                        onSaved={() => {
                            _props.setState({..._props.state});
                        }}
                    />
                },
                filterable: false,
                sortable: false,
                width: 1,
                formatter: (props) => {
                    return <>
                        <Editor
                            {...props}
                            dirtyValues={false}
                            values={props.data}
                            {...{[props.config.idfield]: props?.data?.[props.config.idfield]}}
                            onSaved={() => {
                                props.setState({...props.state});
                            }}
                            onRemoved={() => {
                                props.setState({...props.state});
                            }}
                            children={null}
                        />
                    </>;
                }
            },
            "base": {
                filterable: true,
                sortable: true,
            },
            "id": {
                filterable: true,
                sortable: true,
            },
            "hu": {
                filterable: true,
                sortable: true,
            }
        }}
        {...props}
    />;
});